/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisibilityEnum } from './visibility-enum';
import { DeckPitchDetailRequestLimitPaymentOptionsTo } from './deck-pitch-detail-request-limit-payment-options-to';

/**
 * Basic Pitch serializer used on list action.
 */
export interface PitchBasicRequest {
  slug?: string | null;
  first_end_date?: string | null;
  name: string;
  min_goal?: string | null;
  max_goal?: string | null;
  equity_offered?: string | null;
  short_description?: string;
  pre_money_eval?: string | null;
  start_date?: string | null;
  /**
   * Pitches are closed every half hour
   */
  end_day?: string | null;
  /**
   * public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -
   */
  visibility?: VisibilityEnum;
  payment_due?: string | null;
  homepage?: string | null;
  limit_payment_options_to?: DeckPitchDetailRequestLimitPaymentOptionsTo | null;
  use_teaser?: boolean;
  featured?: boolean;
  tax_deducted?: boolean | null;
  seo_image?: Blob;
  compensation?: string;
}
export namespace PitchBasicRequest {}
